import styles from './termo-de-uso.module.scss'

export function TermoDeUso() {
  return (
    <div className={styles.content}>
      <p>
        Este documento visa registrar a manifestação livre e inequívoca pela qual o Titular concorda
        com o tratamento de seus dados pessoais pela Advocacia Bellinati Perez e/ou BP Gestão e
        Recuperação de Ativos Ltda, ambas sediadas na Avenida Duque de Caxias 882, Torre II, Bairro
        Zona 01, CEP: 87013- 180, em Maringá/PR, doravante denominada de Controladora, conforme
        disposições abaixo:
      </p>

      <h2>
        Autorização
      </h2>

      <p>
        Em observância à Lei nº. 13.709/18 – Lei Geral de Proteção de Dados Pessoais e demais
        normativas aplicáveis sobre proteção de Dados Pessoais, manifesto-me de forma livre, expressa
        e consciente, no sentido de autorizar a Controladora a realizar o tratamento de meus Dados
        Pessoais para as finalidades e de acordo com as condições aqui estabelecidas.
      </p>

      <h2>
        Finalidades do tratamento
      </h2>

      <p>
        O tratamento dos dados pessoais listados neste termo tem as seguintes finalidades:
      </p>

      <ol>
        <li>
          Possibilitar a comunicação pela Controladora, por seus prestadores de serviços ou
          qualquer outra empresa com a qual esteja ligada, seja consorciada, sucedida, vinculada,
          afiliada e/ou coligada, por meio de quaisquer canais de comunicação (e-mail, telefone,
          SMS, WhatsApp, etc.);

        </li>

        <li>
          2. Possibilitar que a Controladora identifique e entre em contato com o Titular
          para fins de relacionamento profissional.
        </li>

        <li>
          3. Possibilitar a controladora atender as exigências trabalhistas e previdenciárias, por meio
          próprio ou por seus prestadores de serviços terceirizados.
        </li>

      </ol>

      <p>
        Estou ciente de que a Controladora poderá compartilhar os meus Dados Pessoais com seus
        parceiros e demais prestadores de serviços, restringindo-se às funções e atividades por cada um
        desempenhadas e em aderência às finalidades acima estabelecidas.

      </p>

      <p>
        Estou ciente de que a Controladora poderá tomar decisões automatizadas com base em meus
        Dados Pessoais, sendo garantido a mim o direito de solicitar a revisão dessas decisões.
      </p>

      <h2>Confidencialidade</h2>

      <p>
        Estou ciente do compromisso assumido pela Controladora de tratar os meus Dados Pessoais de
        forma sigilosa e confidencial, mantendo-os em ambiente seguro e não sendo utilizados para
        qualquer fim que não os descritos acima.
      </p>

      <h2>
        Revogação
      </h2>

      <p>

        Estou ciente que, a qualquer tempo, posso retirar o consentimento ora fornecido, hipótese em
        que as atividades desenvolvidas pela Controladora, no âmbito de nossa relação, poderão restar
        prejudicadas.
      </p>

      <p>
        Declaro e concordo que os meus Dados Pessoais poderão ser armazenados, mesmo após o
        término do tratamento, inclusive após a revogação do consentimento para cumprimento de
        obrigação legal ou regulatória pela Controladora.
      </p>

      <h2>
        Canal de Atendimento
      </h2>

      <p>
        Estou ciente de que posso utilizar o canal de atendimento de Ouvidoria da Controladora, por
        meio do endereço <a href="https://www.bellinatiperez.com.br/ouvidoria/" rel="noreferrer" target="_blank">https://www.bellinatiperez.com.br/ouvidoria/</a>, para tirar dúvidas e/ou
        realizar solicitações relacionadas ao tratamento dos meus Dados Pessoais.

      </p>
      <p>
        Por fim, declaro ter lido e ter sido suficientemente informado sobre o conteúdo deste Termo e
        concordo com o tratamento dos meus Dados Pessoais aqui descrito de forma livre e esclarecida,
        em observância à Lei Geral de Proteção de Dados e às demais normativas sobre proteção de
        Dados Pessoais aplicáveis.
      </p>

      <h2>
        Canal de Comunicação
      </h2>

      <p>
        Manifesto-me de forma livre, expressa e consciente, no sentido de autorizar a Controladora a
        realizar contato comigo através dos seguintes canais:
      </p>

      <ul>
        <li>
          e-mail
        </li>
        <li>
          ligação
        </li>
        <li>
          SMS
        </li>
        <li>
          App de comunicação (WhatsApp)
        </li>
      </ul>

      <h2>
        Especificação e Tratamento de Dados Pessoais
      </h2>

      <p>
        Para atendimento da campanha interna de indicação de currículos, a Controladora realiza a
        coleta de dados pessoais de seus candidatos por meio de seu cadastro
      </p>

      <p>
        Abaixo, apresentamos as informações pessoais coletadas pela Controladora e suas respectivas finalidades:
      </p>

      <ul>
        <li>
          <strong>CPF</strong>: usamos esse dado para permitir a sua identificação no cadastro da Controladora;
        </li>
        <li>
          <strong>Nome</strong>: usamos esse dado para permitir a sua identificação no cadastro da Controladora;
        </li>
        <li>
          <strong>e-mail</strong>: usamos esse dado como meio de comunicação;
        </li>
        <li>
          <strong>Telefone</strong>: usamos esse dado para realizar contato por meio de ligação ou de mensagem de
          texto, para responder às suas solicitações ou pedidos feitos pela Controladora;
        </li>
        <li>
          <strong>Informações de localidade (CEP, UF, cidade, bairro e endereço)</strong>: usamos esses dados para
          permitir a identificação da localidade em que se encontra.
        </li>
      </ul>


    </div>
  )
}
